import { io, Socket } from "socket.io-client";

const SERVER_URL =
  process.env.REACT_APP_SOCKETIO_SERVER_URL || "enomocasino.com";

let socket: Socket | null = null;

export const connectSocket = () => {
  if (!socket) {
    socket = io(SERVER_URL, {
      transports: ["websocket"],
      withCredentials: true,
      auth: { token: localStorage.getItem("game-token") },
      reconnectionAttempts: 2,
      reconnectionDelay: 2000,
    });
  }
  return socket;
};

export const updateSocketAuth = (newToken: string) => {
  if (socket) {
    socket.auth = { token: newToken };
    socket.emit("authenticate", { token: newToken });
  }
};

export { socket };
